import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "NotificationTimingOptions" */ './lazyIndex')
);
export { lazyModule };

export { default as NotificationTimingOption } from './NotificationTimingOption';
